export default __webpack_public_path__ + "static/media/migrateNSM.01db0394.png";